/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../../core/components';
import { Component } from '@angular/core';
import { ClusterService } from '../../../services/utilities';
import { environment } from '../../../../../../../environments/environment';

@Component({
    selector: 'app-lb-client-details',
    templateUrl: './clientDetails.component.html',
    styleUrls: ['./clientDetails.component.scss']
})

export class ClientDetailsComponent extends BaseComponent {
    /**
     * Displays company name on the login page.
     */
    public companyName: string = environment.name;

    /**
     * Store the release version and hostname.
     */
    public applianceDetails: any = {
        releaseVersion: '',
        hostName: ''
    };

    constructor(
        public clusterService: ClusterService,
    ) {
        super();

        const localNode = clusterService.localNode;

        this.applianceDetails = {
            releaseVersion: localNode.clientVersion,
            hostName: localNode.hostname
        };
    }
}
